// @flow
import {
  CLAIM_COPY,
  FORGOT_COPY,
  FORGOT_SUB_HEADER,
  RESET_SUB_HEADER,
  RESET_COPY,
} from './constants';

const determineCopy = (isForClaimAccount: ?boolean, resetPassword: ?boolean) => {
  if (isForClaimAccount) {
    return {
      header: CLAIM_COPY,
      subHeader: RESET_SUB_HEADER,
    };
  }
  if (resetPassword) {
    return {
      header: RESET_COPY,
      subHeader: RESET_SUB_HEADER,
    };
  }
  return {
    header: FORGOT_COPY,
    subHeader: FORGOT_SUB_HEADER,
  };
};

export default determineCopy;



// WEBPACK FOOTER //
// ./src/containers/password-form/helpers.js